module.exports = function getResource(label, vars = []) {
    let resources = {
        useItWithTitle: 'Utiliser avec',
        similarProductsTitle: 'Produits similaires',
        youMayAlsoLikeTitle: 'Vous pourriez aussi aimer',
        recentlyViewedLabel: 'Récemment consulté',
        highlights: 'Avantages',
        ingredients: 'Ingrédients',
        faq: 'FAQ',
        howToUse: 'Mode d’emploi',
        aboutTheBrand: 'À propos de la marque',
        shopAll: 'Découvrir',
        aboutTheProduct: 'À propos du produit',
        item: 'Article',
        showMore: 'Afficher plus',
        showLess: 'Afficher moins',
        availableOnlineOnly: 'En ligne seulement',
        free: 'GRATUIT',
        viewAsList: 'Voir en tant que liste',
        reserveNotAvailable: 'Option Réservation et ramassage non offerte',
        pickUpNotAvailable: 'Option Achat en ligne et ramassage non offerte',
        pickUpNotOfferedForItem: 'Le ramassage n’est pas offert pour cet article',
        downloadOpenApp: 'Pour l’acheter, téléchargez ou ouvrez l’appli Sephora.',
        remove: 'Supprimer',
        viewMoreCleanBeauty: 'Voir plus de produits purs et sains',
        askAQuestion: 'Poser une question'
    };
    return resources[label];
};
